import { Dialog } from "@mui/material";
import { CrossborderTransactionDetail } from "./CrossborderTransactionDetail";

const PAYIN_MODAL_CLASS =
  "!rounded-2xl !shadow-card app-card !m-4 !flex !flex-col !max-h-[85vh] !w-[calc(100%-2rem)] !max-w-4xl";

const PAYOUT_MODAL_CLASS =
  "!rounded-2xl !shadow-card app-card !m-4 !flex !flex-col !max-h-[90vh] !w-[calc(100%-2rem)] !max-w-5xl";

export const CrossborderTransactionDetailDrawer = ({ transaction, onClose }) => {
  const isOpen = Boolean(transaction);
  const isPayout = transaction?.type === "payout";

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth={isPayout ? "lg" : "md"}
      scroll="paper"
      PaperProps={{ className: isPayout ? PAYOUT_MODAL_CLASS : PAYIN_MODAL_CLASS }}
    >
      {transaction ? (
        <CrossborderTransactionDetail
          transaction={transaction}
          onClose={onClose}
          className="!shadow-none !border-0 !rounded-none min-h-0"
        />
      ) : null}
    </Dialog>
  );
};
